import styled from 'styled-components';
const containerMaxWidth = '1480px';

export const StyledPage = styled.div`
  @media only screen {
    max-width: ${containerMaxWidth};
  }
`;

export const ErrorCardWrapper = styled.div`
  margin: 50px 0 0 0;
`;
